import React, { useState, useContext, useEffect } from 'react';
import AdminMasterLayout from '../../../layouts/Admin/AdminMasterLayout';
import { Container, Row, Col, Card, Table, Badge, Modal, Button } from 'react-bootstrap';
import { FaUser, FaCar, FaMapMarkerAlt, FaDollarSign, FaEye, FaTimesCircle, FaTimes, FaClock, FaExclamationTriangle } from 'react-icons/fa';
import '../../../assets/css/Admin/CancelledOrders/CancelledOrders.css';
import axios from 'axios';
import AppContext from '../../../context/AppContext';

const CancelledOrders = () => {
  const { baseUrl, authToken } = useContext(AppContext);
  const [cancelledRides, setCancelledRides] = useState([]);
  const [showModal, setShowModal] = useState(false);
  const [selectedRide, setSelectedRide] = useState(null);

  const handleViewDetails = (ride) => {
    setSelectedRide(ride);
    setShowModal(true);
  };

  const handleCloseModal = () => {
    setShowModal(false);
    setSelectedRide(null);
  };

  useEffect(() => {
    axios.post(`${baseUrl}/admin/orders/viewCancelledOrders`, {}, {
      headers: { Authorization: `Bearer ${authToken}` },
    }).then((response) => {
      if (response.data.success === true) {
        setCancelledRides(response.data.rides);
      }
    }).catch((error) => console.log(error));
  }, []);

  return (
    <AdminMasterLayout screenName="cancelled">
      <Container fluid>
        <h2 className="cancelled-orders-title">Cancelled Orders</h2>

        <Row>
          <Col lg={12}>
            <Card className="cancelled-orders-card">
              <Card.Body>
                <div className="cancelled-orders-table-wrapper">
                  <Table responsive className="cancelled-orders-table">
                    <thead>
                      <tr>
                        <th>Ride ID</th>
                        <th>Customer Details</th>
                        <th>Driver Details</th>
                        <th>Ride Details</th>
                        <th>Fare & Payment</th>
                        <th>Status</th>
                        <th>Cancelled Info</th>
                        <th>Actions</th>
                      </tr>
                    </thead>
                    <tbody>
                      {cancelledRides.length > 0 ? cancelledRides.map((ride) => (
                        <tr key={ride.id}>
                          <td><strong className="cancelled-orders-ride-id">{ride.id}</strong></td>

                          <td>
                            <div className="cancelled-orders-customer-info">
                              <div className="cancelled-orders-info-icon"><FaUser /></div>
                              <div>
                                <strong>{ride.tdcustomer?.customerName}</strong>
                                <p className="cancelled-orders-detail">{ride.tdcustomer?.mobileNumber}</p>
                                <p className="cancelled-orders-detail">{ride.tdcustomer?.customerEmail}</p>
                              </div>
                            </div>
                          </td>

                          <td>
                            <div className="cancelled-orders-driver-info">
                              <div className="cancelled-orders-info-icon driver"><FaCar /></div>
                              <div>
                                <strong>{ride.tddriver?.drivername}</strong>
                                <p className="cancelled-orders-detail">ID: {ride.tddriver?.id}</p>
                                <p className="cancelled-orders-detail">{ride.tddriver?.driverphone}</p>
                              </div>
                            </div>
                          </td>

                          <td>
                            <div className="cancelled-orders-location-info">
                              <div className="cancelled-orders-location-item">
                                <FaMapMarkerAlt className="cancelled-orders-location-icon pickup" />
                                <div><small>Pickup</small><p>{ride.pickuplocation}</p></div>
                              </div>
                              <div className="cancelled-orders-location-item">
                                <FaMapMarkerAlt className="cancelled-orders-location-icon dropoff" />
                                <div><small>Drop-off</small><p>{ride.dropofflocation}</p></div>
                              </div>
                            </div>
                          </td>

                          <td>
                            <div className="cancelled-orders-fare-info">
                              <div className="cancelled-orders-fare-amount">
                                <FaDollarSign />
                                <strong>Rs. {ride.offeredFare}</strong>
                              </div>
                              <Badge
                                bg={ride.paymentmethod === 'cash' ? 'success' : 'info'}
                                className="cancelled-orders-payment-badge"
                              >
                                {ride.paymentmethod}
                              </Badge>
                            </div>
                          </td>

                          <td>
                            <Badge bg="danger" className="cancelled-orders-status-badge">
                              <FaTimesCircle /> Cancelled
                            </Badge>
                          </td>

                          <td>
                            <div className="cancelled-orders-cancel-info">
                              <span className="cancelled-orders-date">{ride.bookingDate}</span>
                            </div>
                          </td>

                          <td>
                            <button className="cancelled-orders-view-btn" onClick={() => handleViewDetails(ride)}>
                              <FaEye /> View
                            </button>
                          </td>
                        </tr>
                      )) : (
                        <tr>
                          <td colSpan="8" className="text-center">No cancelled rides found</td>
                        </tr>
                      )}
                    </tbody>
                  </Table>
                </div>
              </Card.Body>
            </Card>
          </Col>
        </Row>

        <Modal show={showModal} onHide={handleCloseModal} size="lg" centered>
          <Modal.Header closeButton className="cancelled-orders-modal-header">
            <Modal.Title><FaTimesCircle /> Cancelled Ride Details - {selectedRide?.id}</Modal.Title>
          </Modal.Header>
          <Modal.Body className="cancelled-orders-modal-body">
            {selectedRide && (
              <Row>
                <Col md={6} className="mb-4">
                  <Card className="cancelled-orders-detail-card">
                    <Card.Body>
                      <h6 className="cancelled-orders-section-title"><FaUser /> Customer Information</h6>
                      <div className="cancelled-orders-detail-item"><strong>Name:</strong> {selectedRide.tdcustomer?.customerName}</div>
                      <div className="cancelled-orders-detail-item"><strong>Phone:</strong> {selectedRide.tdcustomer?.mobileNumber}</div>
                      <div className="cancelled-orders-detail-item"><strong>Email:</strong> {selectedRide.tdcustomer?.customerEmail}</div>
                    </Card.Body>
                  </Card>
                </Col>

                <Col md={6} className="mb-4">
                  <Card className="cancelled-orders-detail-card">
                    <Card.Body>
                      <h6 className="cancelled-orders-section-title"><FaCar /> Driver Information</h6>
                      <div className="cancelled-orders-detail-item"><strong>Name:</strong> {selectedRide.tddriver?.drivername}</div>
                      <div className="cancelled-orders-detail-item"><strong>Driver ID:</strong> {selectedRide.tddriver?.id}</div>
                      <div className="cancelled-orders-detail-item"><strong>Phone:</strong> {selectedRide.tddriver?.driverphone}</div>
                    </Card.Body>
                  </Card>
                </Col>

                <Col md={12} className="mb-4">
                  <Card className="cancelled-orders-detail-card">
                    <Card.Body>
                      <h6 className="cancelled-orders-section-title"><FaMapMarkerAlt /> Ride Information</h6>
                      <Row>
                        <Col md={6}>
                          <div className="cancelled-orders-detail-item"><strong>Pickup:</strong> {selectedRide.pickuplocation}</div>
                          <div className="cancelled-orders-detail-item"><strong>Drop-off:</strong> {selectedRide.dropofflocation}</div>
                        </Col>
                        <Col md={6}>
                          <div className="cancelled-orders-detail-item"><strong>Vehicle Type:</strong> {selectedRide.vehicleType}</div>
                          <div className="cancelled-orders-detail-item"><strong>Booking Type:</strong> {selectedRide.bookingType}</div>
                        </Col>
                      </Row>
                    </Card.Body>
                  </Card>
                </Col>

                <Col md={12} className="mb-4">
                  <Card className="cancelled-orders-detail-card">
                    <Card.Body>
                      <h6 className="cancelled-orders-section-title"><FaDollarSign /> Payment Details</h6>
                      <div className="cancelled-orders-detail-item"><strong>Total Fare:</strong> Rs. {selectedRide.offeredFare}</div>
                      <div className="cancelled-orders-detail-item">
                        <strong>Payment Method:</strong>{' '}
                        <Badge bg={selectedRide.paymentmethod === 'cash' ? 'success' : 'info'}>
                          {selectedRide.paymentmethod}
                        </Badge>
                      </div>
                    </Card.Body>
                  </Card>
                </Col>

                <Col md={12}>
                  <Card className="cancelled-orders-detail-card">
                    <Card.Body>
                      <h6 className="cancelled-orders-section-title"><FaClock /> Timeline</h6>
                      <div className="cancelled-orders-detail-item"><strong>Booking Date:</strong> {selectedRide.bookingDate}</div>
                      <div className="cancelled-orders-detail-item"><strong>Booking Time:</strong> {selectedRide.bookingTime}</div>
                    </Card.Body>
                  </Card>
                </Col>
              </Row>
            )}
          </Modal.Body>
          <Modal.Footer>
            <Button variant="secondary" onClick={handleCloseModal}><FaTimes /> Close</Button>
          </Modal.Footer>
        </Modal>
      </Container>
    </AdminMasterLayout>
  );
};

export default CancelledOrders;